// packages/ui/src/auth/AuthMobileBar.tsx
import type { ReactNode } from 'react';

export interface AuthMobileBarProps {
  /** Wordmark or logo, in dark text on the white bar. */
  brand: ReactNode;
  homeHref: string;
  /** Product label next to the brand, as on AuthBrandPanel. */
  badge?: string;
  /** Text of the back link on the right. Omit for no link. */
  backLabel?: string;
}

// Compact brand bar shown in place of AuthBrandPanel below `lg`, where the panel is hidden.
export function AuthMobileBar({ brand, homeHref, badge, backLabel }: AuthMobileBarProps) {
  const homeLink = (
    <a href={homeHref} className="flex items-center">
      <span className="text-xl font-bold tracking-tight text-slate-900">{brand}</span>
    </a>
  );

  return (
    <header className="lg:hidden bg-white border-b border-slate-100 px-6 py-4 flex items-center justify-between">
      {badge ? (
        <div className="flex items-center gap-3">
          {homeLink}
          <span className="rounded border border-teal-200 bg-teal-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-teal-700">
            {badge}
          </span>
        </div>
      ) : (
        homeLink
      )}
      {backLabel && (
        <a href={homeHref} className="text-sm text-slate-500 hover:text-teal-600 transition-colors">
          {backLabel}
        </a>
      )}
    </header>
  );
}
